import { useState } from 'react';
import { useFlagsService } from '@atlassian/jira-flags';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';
import { syncDevicesEndpoint } from './endpoints/sync-devices';
import messages from './messages';

export const useSyncDevices = () => {
	const [loading, setLoading] = useState(false);
	const [syncStarted, setSyncStarted] = useState(false);
	const cloudId = useCloudId();
	const { showFlag } = useFlagsService();
	return {
		sync: (items: string[]) => {
			if (loading) return;

			setLoading(true);
			syncDevicesEndpoint(cloudId, items)
				.then(() => {
					setSyncStarted(true);
				})
				.catch(() => {
					showFlag({
						type: 'error',
						title: messages.errorTitleNonFinal,
						description: messages.errorDescriptionNonFinal,
					});
				})
				.finally(() => setLoading(false));
		},
		loading,
		syncStarted,
	};
};
